export default function Footer() {
  return (
    <footer className="bg-amber-950 py-20 border-t border-amber-900/50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div className="md:col-span-1">
            <h3 className="text-2xl font-black text-amber-50 uppercase leading-tight mb-1">
              The Forgotten Felon
            </h3>
            <p className="text-amber-400 font-bold text-sm uppercase tracking-widest mb-6">
              Blueprint
            </p>
            <div className="w-10 h-1 bg-amber-600 mb-8"></div>
            <p className="text-xs text-amber-200/40 leading-relaxed">
              A survival guide for those who want their freedom to mean something.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-amber-400 mb-6">
              Quick Links
            </h4>
            <ul className="space-y-5">
              {[
                { label: 'About the Author', href: '#about' },
                { label: 'Reader Reviews', href: '#reviews' },
                { label: 'Purchase Book', href: '#purchase' },
                { label: 'Contact Author', href: '#' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-amber-200/40 hover:text-amber-400 hover:translate-x-1 inline-block transition-all duration-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-amber-900/50 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-xs text-amber-200/30 mb-4 md:mb-0">
              © 2024 John Reed. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              {['ri-twitter-x-line', 'ri-instagram-line', 'ri-facebook-fill', 'ri-linkedin-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center border border-amber-900/50 text-amber-700 hover:bg-amber-600 hover:text-amber-50 hover:border-amber-600 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
